/**
 * 문서에 AI 칸을 넣는 공통 도구 (문서 AI 초안은 docDraft.ts).
 */
export const AI_DRAFT_MARK = '[AI 초안 — 확인 필요]';
/** 이전 버전 표시도 AI 초안으로 알아본다 */
export const isAiDraftMark = (line: string) =>
  line.trim() === AI_DRAFT_MARK || line.trim() === '[AI 초안 — 검토 후 수정하세요]';

/**
 * 문서 본문의 큰 항목(## …) 끝에 AI 서술 칸을 넣는다. 같은 칸이 이미 있으면 그 칸 내용만 바꾼다 (중복 없음).
 * 원래 칸·상담자가 쓴 다른 내용은 건드리지 않는다.
 */
export function upsertDraftField(
  content: string,
  sectionPrefix: string,
  label: string,
  text: string,
  after?: string,
  /** 큰 항목이 없으면 이 제목으로 새로 만들어 붙인다 (예: 대화록 부록) */
  sectionTitle?: string,
): string {
  const lines = content.replace(/\r/g, '').split('\n');
  const block = [`### ${label}`, AI_DRAFT_MARK, ...text.trim().split('\n'), ''];
  const isHeading = (l: string) => /^#{1,4}\s/.test(l);
  const existing = lines.findIndex((l) => l === `### ${label}`);
  if (existing >= 0) {
    let end = existing + 1;
    while (end < lines.length && !isHeading(lines[end]!)) end++;
    lines.splice(existing, end - existing, ...block);
    return lines.join('\n');
  }
  const start = lines.findIndex((l) => /^##\s/.test(l) && l.slice(3).startsWith(sectionPrefix));
  if (start < 0 && sectionTitle) return `${content.trimEnd()}\n\n## ${sectionTitle}\n\n${block.join('\n')}`;
  if (start < 0) return `${content.trimEnd()}\n\n${block.join('\n')}`;
  let sectionEnd = start + 1;
  while (sectionEnd < lines.length && !/^##?\s/.test(lines[sectionEnd]!)) sectionEnd++;
  // 지정한 칸 바로 뒤 (그 칸의 세부 칸까지 포함), 없으면 큰 항목 끝
  const anchor = after ? lines.slice(start, sectionEnd).findIndex((l) => l.startsWith(after)) : -1;
  let at = sectionEnd;
  if (anchor >= 0) {
    const level = /^(#+)/.exec(after!)![1]!.length;
    at = start + anchor + 1;
    while (at < sectionEnd) {
      const h = /^(#+)\s/.exec(lines[at]!);
      if (h && h[1]!.length <= level) break;
      at++;
    }
  }
  lines.splice(at, 0, ...block);
  return lines.join('\n');
}
